import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import './print.css';
import { useSelector } from 'react-redux';
import generateUUID from 'Utils/generateUUID';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import PipeProvider from 'Services/Providers/PipeProvider';
import { Skeleton } from 'antd';

const Regulation = ({ vendorId, regulationType }) => {
  const { callApi } = usePipeContext();

  const Regulation = useSelector(({ Regulation: data }) => data);
  const profile = useSelector((state) => state.oidc.user.profile);

  let catalogId = profile && profile['custom:catalog_id'];
  let campaignId = profile && profile['custom:campaign_id'];
  const index = `${campaignId || '-'}${catalogId || '-'}${vendorId || '-'}${
    regulationType || '-'
  }`;

  let regulationItem = Regulation.value && Regulation.value[index];
  const regulationListRender =
    regulationItem && regulationItem.result
      ? regulationItem.result.map((regulation) => regulation.html)
      : [];

  const fetchData = (symbol, payload = null) => {
    const alias = generateUUID();
    callApi({
      symbol,
      alias,
      payload,
    });
  };

  useEffect(() => {
    const termContainer = document.querySelector('#term-container li');
    const termLink = document.querySelector('#term-container a');
    termContainer && termContainer.classList.add('color-ui-1');
    termLink && termLink.classList.add('color-brand-1');
  }, []);

  useEffect(() => {
    const listRegulations = () => {
      if (vendorId !== undefined) {
        if (regulationType !== undefined) {
          fetchData('LIST_REGULATION_VENDOR_AND_REGULATION_TYPE', {
            campaignId,
            catalogId,
            vendorId,
            regulationType,
          });
        } else {
          fetchData('LIST_REGULATION_VENDOR', {
            campaignId,
            catalogId,
            vendorId,
          });
        }
      }
    };

    if (!regulationListRender || regulationListRender.length <= 0) {
      listRegulations();
    }
  }, [vendorId, regulationType]);

  return (
    <PipeProvider>
      <div
        className={`${vendorId || 'divPrint'} w-100`}
        role="article"
      >
        {Regulation.isLoading ? (
          <>
            <Skeleton
              paragraph={{ rows: 4 }}
              active
            />
          </>
        ) : (
          regulationListRender.map((regulation, index) => (
            <div
              key={index}
              id="term-container"
              dangerouslySetInnerHTML={{ __html: regulation }}
            />
          ))
        )}
      </div>
    </PipeProvider>
  );
};

Regulation.propTypes = {
  vendorId: PropTypes.number,
  regulationType: PropTypes.string,
};

export default Regulation;
